module.exports = {
    'mobile': '40',
    'tablet': '90',
    'desktop': '90',
    'desktop-l': '100',
  }



// WEBPACK FOOTER //
// ./src/vars/moduleMargins.js